// src/utils/encryption.js
import CryptoJS from "crypto-js";

export const encryptBankData = (data) => {
  // Always stringify to handle both object and string types
  const stringifiedData = JSON.stringify(data);
  return CryptoJS.AES.encrypt(stringifiedData, process.env.REACT_APP_SECRET_KEY).toString();
};

export const encryptData = (data) => {
  const stringifiedData =
    typeof data === "string" ? data : JSON.stringify(data);
  return CryptoJS.AES.encrypt(stringifiedData, process.env.REACT_APP_SECRET_KEY).toString();
};

export const decryptData = (encryptedData) => {
  try {
    if (!encryptedData) return null;
    const bytes = CryptoJS.AES.decrypt(encryptedData, process.env.REACT_APP_SECRET_KEY);
    const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedStr) {
      throw new Error("Empty string after decryption — wrong key?");
    }
    try {
      // Check if it's JSON (object or array) — otherwise just return string
    // if (!decryptedStr.trim().startsWith("{") && !decryptedStr.trim().startsWith("[")) {
    //   return decryptedStr;
    // }
      return JSON.parse(decryptedStr);
    } catch {
      return decryptedStr;
    }
  } catch (error) {
    throw error;
  }
};
